const AUTH_STORAGE_KEYS = new Set([
    'IdToken',
    'RefreshToken',
    'AccessToken',
    'email',
    'user_id',
    'id',
    'user_type',
    'session_token',
    'custom:is_first_time_login',
    'user-info',
    'browser_trust_duration',
    'custom-status',
    'verify_otp_session_token',
    'preference_id',
    'token',
]);

const LOGOUT_EVENT_KEY = 'arcm:logout-event';
const LOGIN_EVENT_KEY = 'arcm:login-event';

const getStorage = (type) => {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        return window[type];
    } catch (error) {
        console.error(`Unable to access ${type}:`, error);
        return null;
    }
};

const session = getStorage('sessionStorage');
const local = getStorage('localStorage');

const serialize = (value) => {
    if (value === undefined || value === null) {
        return null;
    }

    if (typeof value === 'string') {
        return value;
    }

    try {
        return JSON.stringify(value);
    } catch (error) {
        console.warn('Failed to serialise value, storing as string', error);
        return String(value);
    }
};

const setItem = (storage, key, value) => {
    if (!storage || value === null) {
        return;
    }
    try {
        storage.setItem(key, value);
    } catch (error) {
        console.error(`Unable to set ${key} in storage:`, error);
    }
};

const removeItem = (storage, key) => {
    if (!storage) {
        return;
    }
    try {
        storage.removeItem(key);
    } catch (error) {
        console.error(`Unable to remove ${key} from storage:`, error);
    }
};

const readItem = (storage, key) => {
    if (!storage) {
        return null;
    }
    try {
        return storage.getItem(key);
    } catch (error) {
        console.error(`Unable to read ${key} from storage:`, error);
        return null;
    }
};

export const setAuthItem = (key, value) => {
    const serialisedValue = serialize(value);
    if (serialisedValue === null) {
        return;
    }

    AUTH_STORAGE_KEYS.add(key);
    setItem(session, key, serialisedValue);
    setItem(local, key, serialisedValue);
    setItem(local, LOGIN_EVENT_KEY, Date.now().toString());
};

export const getAuthItem = (key) => {
    const sessionValue = readItem(session, key);
    if (sessionValue !== null && sessionValue !== undefined && sessionValue !== '') {
        return sessionValue;
    }
    return readItem(local, key);
};

export const removeAuthItem = (key) => {
    removeItem(session, key);
    removeItem(local, key);
};

export const persistAuthSession = (entries) => {
    if (!entries || typeof entries !== 'object') {
        return;
    }
    Object.entries(entries).forEach(([key, value]) => {
        setAuthItem(key, value);
    });
};

export const syncSessionFromLocalStorage = () => {
    if (!local || !session) {
        return;
    }

    AUTH_STORAGE_KEYS.forEach((key) => {
        const hasSessionValue = readItem(session, key);
        if (hasSessionValue === null || hasSessionValue === undefined || hasSessionValue === '') {
            const localValue = readItem(local, key);
            if (localValue !== null && localValue !== undefined) {
                setItem(session, key, localValue);
            }
        }
    });
};

export const clearAuthSession = () => {
    AUTH_STORAGE_KEYS.forEach((key) => {
        removeAuthItem(key);
    });
};

export const broadcastLogout = () => {
    setItem(local, LOGOUT_EVENT_KEY, Date.now().toString());
};

export const subscribeToAuthEvents = (handler) => {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
        return () => {};
    }

    const listener = (event) => {
        if (event.key === LOGOUT_EVENT_KEY) {
            handler('logout');
        }
        if (event.key === LOGIN_EVENT_KEY) {
            handler('login');
        }
    };

    window.addEventListener('storage', listener);
    return () => window.removeEventListener('storage', listener);
};


